module.exports = __webpack_public_path__ + "img/apple-pay-logo-lg.7976dc63.svg";